module.exports = __webpack_public_path__ + "static/media/logo_login.3de1d669.png";